(function () {
  var bar = document.querySelector('[data-ticker-1925]');
  if (!bar) return;

  var root = document.documentElement;
  var closedKey = '1925_ticker_closed';

  // En el grupo Encabezado el ticker es una barra fija ARRIBA DEL TODO (encima del
  // menú); el menú baja su altura. Se oculta al hacer scroll y no reaparece (el menú
  // sigue sticky). Como sección normal en una plantilla: flujo normal, siempre visible.
  var group = bar.closest('.shopify-section-group-header-group');
  var isHeaderTicker = !!group;

  function setTickerVisible(visible) {
    root.classList.toggle('ticker-1925-dismissed', !visible);
    updateTickerHeight();
  }

  function updateTickerHeight() {
    if (bar.hidden || root.classList.contains('ticker-1925-dismissed')) {
      root.style.removeProperty('--header-ticker-height');
      root.classList.remove('home-has-ticker-1925');
      return;
    }
    root.style.setProperty('--header-ticker-height', bar.offsetHeight + 'px');
    root.classList.add('home-has-ticker-1925');
  }

  // Ocultar al hacer scroll y no volver a mostrarlo (solo visible en el tope inicial).
  function onScroll() {
    if (!isHeaderTicker) return;
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > 1) {
      root.classList.add('ticker-1925-scrolled');
    }
  }

  if (sessionStorage.getItem(closedKey) === '1') {
    bar.hidden = true;
    setTickerVisible(false);
  } else {
    setTickerVisible(true);
  }

  var closeBtn = bar.querySelector('[data-home-announcement-close]');
  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      bar.hidden = true;
      sessionStorage.setItem(closedKey, '1');
      setTickerVisible(false);
    });
  }

  if (isHeaderTicker) {
    window.addEventListener('scroll', onScroll, { passive: true });
  }
  window.addEventListener('resize', updateTickerHeight, { passive: true });
  window.addEventListener('load', function () {
    onScroll();
    updateTickerHeight();
  });

  if (typeof ResizeObserver !== 'undefined') {
    new ResizeObserver(updateTickerHeight).observe(bar);
  }
})();
